import { render, staticRenderFns } from "./SimulationBanner.vue?vue&type=template&id=e79c106c&scoped=true&"
import script from "./SimulationBanner.vue?vue&type=script&lang=js&"
export * from "./SimulationBanner.vue?vue&type=script&lang=js&"
import style0 from "./SimulationBanner.vue?vue&type=style&index=0&id=e79c106c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79c106c",
  null
  
)

export default component.exports